'use strict';
import * as $j_app$002elocalization$002e$002dL18n$0024 from "./app.localization.-L18n$.js";
import * as $j_app$002ewebclient$005fprelude$002eprelude$002e$002dApp$002dIcons$0024 from "./app.webclient_prelude.prelude.-App-Icons$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$() {
}
export { $c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ as $c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ };
$p = $c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$() {
}
export { $h_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ as $h_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ };
$h_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$.prototype = $p;
$p.bGO = (function(obj, x$2) {
  return obj.bpT($j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().aVp.bD(x$2), $j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().aVq.bD(x$2), $j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().ahP.bD(x$2), $j_app$002ewebclient$005fprelude$002eprelude$002e$002dApp$002dIcons$0024.$m_Lapp_webclient\uff3fprelude_prelude_AppIcons$().adO());
});
var $d_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$, "app.webclient_prelude.exts.ButtonContentsExts$package$", ({
  Ix: 1
}));
export { $d_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ as $d_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ };
var $n_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$;
function $m_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$() {
  if ((!$n_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$)) {
    $n_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ = new $c_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$();
  }
  return $n_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$;
}
export { $m_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ as $m_Lapp_webclient\uff3fprelude_exts_ButtonContentsExts$package$ };
//# sourceMappingURL=app.webclient_prelude.exts.-Button-Contents-Exts$package$.js.map
